export const GET_DAYOFWEEK_REPORT='GET_DAYOFWEEK_REPORT'
export const GET_DAYOFWEEK_REPORT_SUCCESS='GET_DAYOFWEEK_REPORT_SUCCESS'
export const GET_DAYOFWEEK_REPORT_ERROR='GET_DAYOFWEEK_REPORT_ERROR'

export const GetDayOfWeekReport = (data) => ({
    type: GET_DAYOFWEEK_REPORT,
    payload: data
})